import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

import { Observable, throwError } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { take, map, catchError } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class LevelingService {
    
  constructor(private http: HttpClient) { }

  public findGuestHoursByDate(startDate: string, endDate: string): any {
    let params = new HttpParams()
                    .set('startDate', startDate)
                    .set('endDate', endDate);
                        
    return this.http.get(`${environment.api}/levelings/hours`, { params }).pipe(
      map((result: any) => result.data),
      catchError(this.handleError)
    )
  }

  public findHoursByDate(startDate: string, endDate: string): any {
    let params = new HttpParams()
                    .set('startDate', startDate)
                    .set('endDate', endDate);
                    
    return this.http.get(`${environment.api}/levelings/hours`, { params }).toPromise().then((data: any) => data.data.hours);
  }

  public findStudentsByHourId(hourId: number): Observable<any> {    
    return this.http.get(`${environment.api}/levelings/hours/${hourId}/students`).pipe(
      map((result: any) => result.data),
      catchError(this.handleError)
    )
  }
  
  public insert(data: any): Observable<String> {
    return this.http.post<any>(`${environment.api}/levelings`, data).pipe(
      map(result => result.message),
      catchError(this.handleError)
    )
  }

  public update(data: any[]): Observable<string> {
    return this.http.put<any>(`${environment.api}/levelings`, {students: data}).pipe(
      map(result => result.message),
      catchError(this.handleError)
    )
  }

  public findLevelings(search: string) {
    return this.http.get<any>(`${environment.api}/levelings`).pipe(
      map(result => {
        console.log(result)
      }),
      catchError(this.handleError)
    )
  }

  public findByStudent(): Observable<any> {
    return this.http.get(`${environment.api}/levelings`).pipe(
      map((result: any) => result.data),
      catchError(this.handleError)
    )
  }

  public filterStudents(data: any) {
    console.log(data);    
    let params = new HttpParams()
                    .set('name', data.name)
                    .set('year', data.year)
                    .set('modality', data.modality)
                    .set('status', data.status)
                    .set('page', data.page)
                    .set('limit', data.limit)
                    .set('semester', data.semester);

    return this.http.get<any>(`${environment.api}/levelings/search`, { params }).pipe(

    )
  }


  // METHODS PRIVATES
  private handleError(error: any): Observable<any> {
    //console.error("ERRO NA REQUISIÇÃO =>", error);
    return throwError(error);
  }
}
